<template>
    <div>
        <perfect-scrollbar class="ps-popup">
            <div class="product-info-box__add-list-predefined">
                <label class="product-info-box__add-list-predefined-checkbox">
                    <input
                        :checked="favorites[product.ID]"
                        type="checkbox"
                        name="compare"
                        @click="addToFavorites($event)"
                    />
                    <span>Favorites</span>
                </label>
                <a
                    class="product-info-box__add-list-predefined-cta-btn"
                    :href="kadraGlobal.Url + '/single-my-lists?id=favorites'"
                    >View List</a
                >
            </div>
            <div v-for="wish in wishlist" :key="wish.ID">
                <div class="product-info-box__add-list-predefined">
                    <label
                        class="product-info-box__add-list-predefined-checkbox"
                    >
                        <input
                            :checked="check(wish.ID)"
                            type="checkbox"
                            name="compare"
                            @click="addToWishlist(wish.ID, $event)"
                        />
                        <span v-html="wish.title"></span>
                    </label>
                    <a
                        class="product-info-box__add-list-predefined-cta-btn"
                        :href="
                            kadraGlobal.Url + '/single-my-lists?id=' + wish.ID
                        "
                        >View List</a
                    >
                </div>
            </div>
        </perfect-scrollbar>
        <div
            :class="{
                'product-info-box__add-list-cta-wrapper js-product-info-box__add-list-cta-wrapper product-info-box__add-list-cta-wrapper--active': newList,
                'product-info-box__add-list-cta-wrapper js-product-info-box__add-list-cta-wrapper': !newList
            }"
        >
            <a
                class="product-info-box__add-list-cta js-product-info-box__add-list-cta"
                href="javascript:;"
                @click="newList = !newList"
                >add new list</a
            >
            <div class="product-info-box__add-list-edit-name">
                <input type="text" placeholder="List Name" ref="inputTitle" />
                <a
                    class="product-info-box__add-list-btn js-product-info-box__add-list-btn"
                    href="javascript:;"
                    @click="createWishlist()"
                    >Save</a
                >
            </div>
        </div>
    </div>
</template>
<script>
import { PerfectScrollbar } from 'vue2-perfect-scrollbar';

export default {
    props: ['product', 'favorites', 'productWishlist', 'wishlist'],
    data() {
        return {
            newList: false,
            kadraGlobal: kadraGlobal
        };
    },
    components: {
        PerfectScrollbar
    },
    methods: {
        addToFavorites(event) {
            const _self = event.currentTarget;
            _self.parentElement.classList.add('loading');
            setTimeout(() => {
                _self.parentElement.classList.remove('loading');
            }, 1000);
            event.target.checked
                ? this.$store.dispatch('addToFavorites', this.product.ID)
                : this.$store.dispatch('removeFromFavorites', this.product.ID);
        },
        createWishlist() {
            const val = this.$refs.inputTitle.value;
            if (val !== '') {
                this.$store.dispatch('createWishlist', {
                    id: this.product.ID,
                    title: val
                });
                this.$refs.inputTitle.value = '';
                this.newList = false;
            }
        },
        addToWishlist(id, event) {
            const _self = event.currentTarget;
            _self.parentElement.classList.add('loading');
            setTimeout(() => {
                _self.parentElement.classList.remove('loading');
            }, 1000);
            const obj = {
                listId: id,
                product_id: this.product.ID
            };
            event.target.checked
                ? this.$store.dispatch('addToWishlist', obj)
                : this.$store.dispatch('removeFromWishlist', obj);
        },
        check(id) {
            const arr = this.productWishlist[id];
            const productId = this.product.ID.toString();
            if (arr && arr.length !== 0) {
                if (arr.includes(productId)) {
                    return true;
                }
            }
        }
    }
};
</script>

<style lang="scss" scoped>
.product-info-box__add-list-edit-name {
    input {
        width: 120px;
        height: 40px;
        padding: 0 10px;
    }

    .product-info-box__add-list-btn {
        height: 40px;
    }
}
</style>
